import { IntegrationShell } from "../../common/Shell";
import { Navigate, useNavigate, useOutletContext } from "react-router-dom";
import CustomSIPForm from "./CustomSIPForm";
import { useLayoutEffect } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

export default function CustomSIPIntegration() {
  const { projectId, thirdpartyData, updateThirdpartyData, company, isThirdPartyLoading, isViewOnly } =
    useOutletContext();

  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (
      company &&
      !company.thirdPartyIntegrationVisibility.showCustomSipIntegration
    ) {
      navigate("/not-found", { replace: true });
    }
  }, [company]);

  if (!company) {
    return null;
  }

  if (
    company &&
    company?.thirdPartyIntegrationVisibility &&
    !company.thirdPartyIntegrationVisibility.showCustomSipIntegration
  ) {
    return (
      <Navigate
        to="not-found"
        replace
      />
    );
  }

   if (isThirdPartyLoading) {
      return (
        <div className="w-full h-full flex items-center justify-center">
          <AiOutlineLoading3Quarters className="animate-spin" />
        </div>
      );
    }

  return (
    <IntegrationShell>
      <CustomSIPForm
        workspaceId={projectId}
        customSipSettings={thirdpartyData?.telephonySettings?.livekitSettings}
        updateCustomSipSettings={updateThirdpartyData}
        isViewOnly={isViewOnly}
      />
    </IntegrationShell>
  );
}
